import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { StatsSection } from './components/StatsSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1651357612587495';
type MetaPixel = {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & Partial<MetaPixel>;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showPurchaseNotifications?: boolean;
  showCountdown?: boolean;
}
export function App({
  showPurchaseNotifications = true,
  showCountdown = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        } as ((...args: unknown[]) => void) & MetaPixel;
        pixel.queue = [];
        pixel.push = (...args: unknown[]) => pixel.queue.push(args);
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        if (!window._fbq) window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-ivory text-charcoal selection:bg-orange/25 selection:text-charcoal" data-id="element-0" data-mp="86clr5yt79k6">
      <main data-id="element-1" data-mp="3gja2rs1n9oao">
        <Hero data-id="element-2" data-mp="3bmbf9schkflg" />
        <TestimonialsStrip data-id="element-3" data-mp="3bmtjbb5e3y3x" />
        <PainPoints data-id="element-4" data-mp="3bnmgpliglb9e" />
        <SolutionReveal data-id="element-5" data-mp="3bo4kr4bd4trv" />
        <VolumesSection data-id="element-6" data-mp="3qb7inc3ll4fq" />
        <BonusSection showCountdown={showCountdown} data-id="element-7" data-mp="3qbpl4qgusew3" />
        <PricingSection data-id="element-8" data-mp="3qdai0mqn49x4" />
        <StatsSection data-id="element-9" data-mp="3lkr5zu7lpmuf" />
        <ExtendedTestimonials data-id="element-10" data-mp="3lk7ky4mnmic6" />
        <Guarantee data-id="element-11" data-mp="3liwge2ldx6k0" />
        <FAQ data-id="element-12" data-mp="3limryjfzn7gf" />
        <FinalCTA data-id="element-13" data-mp="2xuwtjdr720ap" />
      </main>
      <Footer data-id="element-14" data-mp="2xu3n6dw5dct3" />
      <noscript data-id="element-15" data-mp="2xtlolam0imi0">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-16" data-mp="2xt29s2rnse87" />
      </noscript>
      {showPurchaseNotifications && <PurchaseNotifications data-id="element-17" data-mp="1d4rf4xuynreq" />}
    </div>;
}